<div>
  <!-- First line -->
  <div class="mb-2 flex justify-between">
    <div class="text-label">{{ task().title }}</div>
    <div class="text-r1-blue-800">{{ task().accountNumber }}</div>
  </div>
  <!-- Second line -->
  @if (task().taskState) {
    <div
      class="mb-2 inline-block rounded border border-solid border-gray-300 bg-gray-100 px-2"
    >
      {{ task().taskState }}
    </div>
  }
  <!-- Third line -->
  <div class="flex justify-between">
    <div class="text-label text-red-600">{{ task().oppValue | currency }}</div>
    <ri-resolution-ui-task-date-label
      [task]="task()"
    ></ri-resolution-ui-task-date-label>
  </div>
</div>
